import "core-js/modules/es.array.push.js";
import draggable from 'vuedraggable';
import Bus from '@/assets/js/bus.js';
import { mapState } from 'vuex';
import AWS from 'aws-sdk';
import { handleLocalStorage } from '@/assets/js/utils.js';
export default {
  props: {
    firstLogoList: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  components: {
    draggable
  },
  data() {
    return {
      activeName: 'Logo',
      imageUrl: '',
      pictureList: [],
      showPosition: true,
      positionInfo: {
        title: 'kioskHost.placingPositionSetting',
        show: false,
        save: 'startNewParty.apply',
        cancel: 'start.cancel',
        class: 'positionDailog'
      },
      radio: '1',
      // positionP1: require('@/assets/img/position1.png'),
      // positionP2: require('@/assets/img/position2.png'),
      getImageTimer: null,
      backgroundInfo: {},
      // 用来记录background信息
      uploadFile: null,
      uploadObj: {},
      uploadParams: {},
      getUploadParams: {
        pageIndex: 1,
        pageSize: 20,
        nameLike: '',
        isDirectory: false,
        region: handleLocalStorage('get', 'region'),
        service: 'pp',
        type: 1,
        directoryName: '/Partyline/kiosk/logo'
      },
      uploadFileInfo: null,
      // 用来记录保存要上传 image 信息的，好在后面获取图片宽和高
      uploadLogoInfo: {
        width: 66,
        height: 66
      } // 用来记录刚上传的图片的宽和高
    };
  },

  computed: {
    ...mapState({
      State: state => state
    })
  },
  watch: {
    activeName(newVal, oldVal) {
      this.pictureList = [];
      if (newVal === 'Background') {
        this.showPosition = false;
        this.getUploadBg();
      } else {
        this.showPosition = true;
        this.getUploadLogo();
      }
    }
  },
  created() {
    this.getUploadLogo();
    Bus.$on('changeHadSelectInfo', info => {
      this.pictureList.forEach((item, index) => {
        if (item.name === info.name) {
          this.$set(this.pictureList, index, JSON.parse(JSON.stringify(info)));
          this.$set(this.State.selectLogoInfo, item.name, JSON.parse(JSON.stringify(info)));
        }
      });
    });
  },
  methods: {
    getUploadLogo(byAdd) {
      this.getUploadParams.directoryName = '/Partyline/kiosk/logo';
      this.axios.post('/file/query-user-files', this.getUploadParams, {
        requestBase: 'GATEWAY'
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const list = res.data.result.records;
          const _this = this;
          list.forEach((item, index) => {
            _this.State.hadSelectUpLogo.includes(item.name) ? item.active = true : item.active = false;
            item.isAdd = true;
            if (this.uploadLogoInfo[item.id] && byAdd) {
              const {
                width,
                height
              } = this.dealLogoWH(this.uploadLogoInfo[item.id]);
              item.realWidth = width;
              item.realHeight = height;
            } else {
              // logo 默认值宽最大 66px， 高最高 66px
              const {
                width,
                height
              } = this.dealLogoWH(item);
              item.realWidth = width;
              item.realHeight = height;
              // 对已经进行过选择的使用保存的数据
              if (this.State.selectLogoInfo[item.name]) {
                this.$set(list, index, _this.State.selectLogoInfo[item.name]);
              }
            }
          });
          this.pictureList = list;
        }
      });
    },
    dealLogoWH(item) {
      const obj = {
        width: 66,
        height: 66
      };
      if (item.width < 66 && item.height < 66) {
        obj.width = item.width;
        obj.height = item.height;
        return obj;
      }
      if (item.width >= 66) {
        obj.width = 66;
        obj.height = parseInt(item.height * 66 / item.width);
        return obj;
      }
      if (item.height >= 66) {
        obj.height = 66;
        obj.width = parseInt(item.width * 66 / item.height);
        return obj;
      }
      return obj;
    },
    getUploadBg() {
      this.getUploadParams.directoryName = '/Partyline/kiosk/background';
      this.axios.post('/file/query-user-files', this.getUploadParams, {
        requestBase: 'GATEWAY'
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const list = res.data.result.records;
          list.forEach(item => {
            this.State.hadSelectUpBg.name && this.State.hadSelectUpBg.name.includes(item.name) ? item.active = true : item.active = false;
          });
          this.pictureList = list;
          // 这步为了解决当选择过bg但是却不点Done而是返回时会产生的问题
          if (this.State.hadSelectUpBg.name) {
            this.backgroundInfo = this.State.hadSelectUpBg;
          }
        }
      });
    },
    change() {},
    dragEnd() {},
    handleClick(event) {
      if (this.getImageTimer) clearTimeout(this.getImageTimer);
      this.getImageTimer = setTimeout(() => {
        this.State.activeName = event.name;
      }, 800);
    },
    save() {},
    setDefault() {
      if (JSON.stringify(this.State.selectLogoInfo) != '{}') {
        Object.keys(this.State.selectLogoInfo).forEach(name => {
          // 把那些没有点击 Apply 的清除掉这是一种情况
          if (!this.State.selectLogoInfo[name].isApply) {
            this.State.hadSelectUpLogo.forEach((logoName, index) => {
              if (name === logoName) {
                this.State.hadSelectUpLogo.splice(index, 1);
                Bus.$emit('setLogo', false, this.State.selectLogoInfo[name]);
                this.$delete(this.State.selectLogoInfo, name);
              }
            });
          }
        });
        // 还有一种情况是刚选中 logo 但是没有任何操作
        this.State.hadSelectUpLogo.forEach((name, index) => {
          if (!this.State.selectLogoInfo[name]) {
            this.State.hadSelectUpLogo.splice(index, 1);
            Bus.$emit('setLogo', false, {
              name
            });
          }
        });
      }
    },
    selectPicture(info) {
      // 首先判断在哪个模块下是上传logo还是背景图,logo可以多选 background单选
      const isSelect = info.active;
      if (this.activeName === 'Logo') {
        if (isSelect) {
          this.State.hadSelectUpLogo.forEach((item, index) => {
            if (item === info.name) {
              this.State.hadSelectUpLogo.splice(index, 1);
            }
          });
        } else {
          this.State.hadSelectUpLogo.push(info.name);
        }
        info.active = !info.active;
        Bus.$emit('setLogo', info.active, info);
      } else {
        if (isSelect) {
          this.State.hadSelectUpBg = {};
        } else {
          this.State.hadSelectUpBg = info;
        }
        this.pictureList.forEach(item => {
          if (item.name != info.name) item.active = false;
        });
        info.active = !info.active;
        this.backgroundInfo = {
          ...info,
          active: info.active
        };
        this.$emit('setBgImg', info, info.active);
      }
    },
    showActive(name) {
      const selectArray = this.activeName === 'Logo' ? this.State.hadSelectUpLogo : this.State.hadSelectUpBg.name;
      if (selectArray && selectArray.includes(name)) return 'active';
    },
    setSideBar() {
      const params = {
        partyCode: this.State.partyCode,
        module: 'setBar',
        msg: {
          setBar: {
            position: 'right'
          }
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=43091', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.State.hasKioskSideBar = true;
        }
      });
    },
    cancelSideBar() {
      const params = {
        partyCode: this.State.partyCode,
        module: 'cancelBar',
        msg: {
          setBar: {
            position: 'right'
          }
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=43091', params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.State.hasKioskSideBar = false;
        }
      });
    },
    calculatorWidthHeight(logoInfo, type) {
      let {
        realX = 0,
        realY = 0,
        realWidth,
        realHeight
      } = logoInfo;
      if (type === 'send') {
        realX = Number((realX / this.State.kioskSideBarInfo.width * 100).toFixed(2));
        realY = Number((realY / this.State.kioskSideBarInfo.height * 100).toFixed(2));
        realWidth = Number((realWidth / this.State.kioskSideBarInfo.width * 100).toFixed(2));
        realHeight = Number((realHeight / this.State.kioskSideBarInfo.height * 100).toFixed(2));
      } else {
        realX = Number((realX * this.State.kioskSideBarInfo.width / 100).toFixed(0));
        realY = Number((realY * this.State.kioskSideBarInfo.height / 100).toFixed(0));
        realWidth = Number((realWidth * this.State.kioskSideBarInfo.width / 100).toFixed(0));
        realHeight = Number((realHeight * this.State.kioskSideBarInfo.height / 100).toFixed(0));
      }
      return {
        realX,
        realY,
        realWidth,
        realHeight
      };
    },
    setPicture() {
      const sendLogoList = [];
      const sendLogoName = [];
      if (!this.State.hasKioskSideBar) {
        this.setSideBar();
      }
      this.State.hadSelectUpLogo.forEach(name => {
        this.pictureList.forEach(item => {
          if (name === item.name) {
            if (item.isAdd) {
              const {
                realX,
                realY,
                realWidth,
                realHeight
              } = this.calculatorWidthHeight(item, 'send');
              item.realX = realX;
              item.realY = realY;
              item.realWidth = realWidth;
              item.realHeight = realHeight;
              item.isAdd = false;
            }
            sendLogoName.push(item.name);
            sendLogoList.push(item);
          }
        });
      });
      if (!sendLogoList.length && this.State.hasKioskSideBar) this.cancelSideBar();
      const params = {
        logos: sendLogoList
      };
      this.axios.post(`/partyline-backend/partyAction/setLogos?partyCode=${this.State.partyCode}&key=43091`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.State.isApplyLogo = !this.State.isApplyLogo;
          this.$message.success(this.$t('kioskHost.setLogoS'));
          // 如果没有要设置的 logo 则清楚数据
          if (!sendLogoList.length) this.State.selectLogoInfo = {};
          if (JSON.stringify(this.State.selectLogoInfo) != '{}') {
            Object.keys(this.State.selectLogoInfo).forEach(name => {
              if (!sendLogoName.includes(name)) {
                this.$delete(this.State.selectLogoInfo, name);
              } else {
                this.State.selectLogoInfo[name].isApply = true;
              }
            });
          }
          this.getUploadLogo();
        }
      });
    },
    setBackgroundImg() {
      const params = {
        name: this.backgroundInfo.active ? this.backgroundInfo.name : '',
        url: this.backgroundInfo.active ? this.backgroundInfo.url : ''
      };
      this.$emit('callBack', params);
      this.axios.post(`/partyline-backend/partyAction/setBackground?partyCode=${this.State.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.State.isApplyBg = !this.State.isApplyBg;
          this.$message.success(this.$t('kioskHost.setBackGroundS'));
        }
      });
    },
    applyImg(info) {
      if (this.activeName === 'Logo') {
        this.setPicture();
      } else {
        this.setBackgroundImg();
      }
    },
    // 上传图片相关
    handleChange(file) {
      this.uploadFile = file;
    },
    judgeAllowUpload(file) {
      const isAllowUpload = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isAllowUpload) {
        this.$message.warning('Operation failed, the current picture is not jpeg or png.');
      } else {
        this.uploadFileInfo = file;
      }
      return isAllowUpload;
    },
    uploadFileBySDK() {
      const params = {
        region: handleLocalStorage('get', 'region'),
        service: 'pp',
        directoryName: this.activeName === 'Logo' ? '/Partyline/kiosk/logo' : '/Partyline/kiosk/background',
        fileName: this.uploadFile.name
      };
      this.axios.post('/file/request-upload-for-sdk', params, {
        requestBase: 'GATEWAY'
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.uploadParams = result;
          AWS.config.region = result.identityPoolRegion;
          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: result.identityPoolId
          });
          this.doUploadFile(this.uploadFile);
        }
      });
    },
    doUploadFile(file) {
      this.uploadObj = new AWS.S3.ManagedUpload({
        params: {
          Bucket: this.uploadParams.bucket,
          Key: this.uploadParams.objectKey,
          Body: file.raw,
          ACL: 'public-read'
        },
        service: new AWS.S3({
          region: this.uploadParams.region
        })
      });
      this.uploadObj.promise().then(data => {
        this.saveResult();
      });
    },
    saveResult() {
      const params = {
        bucketId: this.uploadParams.bucketId,
        directoryId: this.uploadParams.directoryId,
        objectKey: this.uploadParams.objectKey
      };
      this.axios.post('/file/add-file', params, {
        requestBase: 'GATEWAY'
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          this.getImageSize(this.uploadFileInfo, res.data.result);
          this.activeName === 'Logo' ? this.getUploadLogo('byAdd') : this.getUploadBg();
          this.$message.success(this.$t('kioskHost.saveSuccess'));
        }
      });
    },
    getImageSize(file, logoId) {
      const _this = this;
      new Promise(function (resolve, reject) {
        const url = window.URL || window.webkitURL;
        const image = new Image();
        image.onload = () => {
          _this.uploadLogoInfo[logoId] = {
            width: image.width,
            height: image.height
          };
          resolve();
        };
        image.src = url.createObjectURL(file);
      }).then().catch(error => {
        reject(error);
      });
    },
    deleteUpload(event, item) {
      let isCanDelete = true;
      // 判断当前是否是在应用状态
      if (event.currentTarget.parentNode.className.includes('active')) {
        this.$message.warning(this.$t('kioskHost.operateImageFailed'));
        return;
      }
      this.firstLogoList.forEach(info => {
        if (item.name == info.name) {
          isCanDelete = false;
          this.$message.warning(this.$t('kioskHost.operateImageFailedPip'));
        }
      });
      if (!isCanDelete) return;
      this.$confirm(this.$t('kioskHost.confirmTodelete'), this.activeName === 'Background' ? this.$t('kioskHost.deleteBackgroundImg') : this.$t('kioskHost.deleteUploadImg'), {
        confirmButtonText: this.$t('kioskHost.yes'),
        cancelButtonText: this.$t('start.cancel')
      }).then(() => {
        const params = {
          id: item.id
        };
        this.axios.post('/file/delete', params, {
          requestBase: 'GATEWAY'
        }).then(res => {
          if (res.data.errorCode === '0x0') {
            this.pictureList.forEach((val, index) => {
              if (val.id == item.id) {
                this.pictureList.splice(index, 1);
                if (this.uploadLogoInfo[item.id]) {
                  this.uploadFileInfo = null;
                  this.$delete(this.uploadLogoInfo, item.id);
                }
              }
            });
            this.$message.success(this.$t('kioskHost.deleteSuccess'));
          }
        });
      });
    }
  }
};